import React from "react";
import { XIcon, TargetIcon } from "lucide-react";
import { Button } from "../ui/button";

interface ChallengeDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToChallenges: () => void;
}

export const ChallengeDialog: React.FC<ChallengeDialogProps> = ({
  isOpen,
  onClose,
  onGoToChallenges,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl p-6 sm:p-8 max-w-md w-full relative overflow-hidden">
        {/* Close button - Fixed with higher z-index */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-gray-400 hover:text-gray-600 transition-colors z-20"
        >
          <XIcon className="w-6 h-6" />
        </button>

        {/* Confetti decorations */}
        <div className="absolute inset-0 pointer-events-none z-0">
          {/* Left side confetti */}
          <div className="absolute top-8 left-8 w-4 h-2 bg-red-300 rounded-full transform rotate-45"></div>
          <div className="absolute top-12 left-12 w-3 h-1 bg-yellow-300 rounded-full transform -rotate-12"></div>
          <div className="absolute top-20 left-6 w-2 h-4 bg-pink-300 rounded-full transform rotate-75"></div>
          <div className="absolute top-24 left-16 w-3 h-2 bg-orange-300 rounded-full transform -rotate-30"></div>
          <div className="absolute top-32 left-10 w-2 h-3 bg-purple-300 rounded-full transform rotate-60"></div>

          {/* Right side confetti */}
          <div className="absolute top-8 right-8 w-4 h-2 bg-red-300 rounded-full transform -rotate-45"></div>
          <div className="absolute top-12 right-12 w-3 h-1 bg-yellow-300 rounded-full transform rotate-12"></div>
          <div className="absolute top-20 right-6 w-2 h-4 bg-pink-300 rounded-full transform -rotate-75"></div>
          <div className="absolute top-24 right-16 w-3 h-2 bg-orange-300 rounded-full transform rotate-30"></div>
          <div className="absolute top-32 right-10 w-2 h-3 bg-purple-300 rounded-full transform -rotate-60"></div>

          {/* Additional scattered confetti */}
          <div className="absolute top-16 left-1/4 w-2 h-2 bg-blue-300 rounded-full transform rotate-45"></div>
          <div className="absolute top-28 right-1/4 w-3 h-1 bg-green-300 rounded-full transform -rotate-30"></div>
          <div className="absolute top-36 left-1/3 w-1 h-3 bg-indigo-300 rounded-full transform rotate-90"></div>
          <div className="absolute top-40 right-1/3 w-2 h-2 bg-teal-300 rounded-full transform -rotate-45"></div>
        </div>

        {/* Challenge icon with gradient background */}
        <div className="flex justify-center mb-6 relative z-10">
          <div className="w-16 h-16 bg-gradient-to-r from-[#6b2cfe] to-[#0217ff] rounded-full flex items-center justify-center shadow-lg relative">
            <TargetIcon className="w-8 h-8 text-white" />
            {/* Animated pulse ring */}
            <div className="absolute inset-0 w-16 h-16 bg-gradient-to-r from-[#6b2cfe] to-[#0217ff] rounded-full animate-ping opacity-20"></div>
          </div>
        </div>

        {/* Content */}
        <div className="text-center relative z-10">
          <h2 className="text-2xl font-bold text-[#373e46] mb-4">
            Dapatkan point dengan challenge
          </h2>
          <p className="text-[#373e46] mb-8 leading-relaxed">
            Dapatkan tambahan point dengan melakukan challenge harian yang sudah
            tersedia.
          </p>

          {/* Challenge button */}
          <Button
            onClick={onGoToChallenges}
            className="w-full h-12 bg-gradient-to-r from-[#6b2cfe] to-[#0217ff] hover:opacity-90 text-white font-semibold rounded-xl transition-all duration-300 hover:shadow-lg"
          >
            Ke Halaman Challenge
          </Button>
        </div>
      </div>
    </div>
  );
};
